/**
 *
 * @description: 华泰资管基金
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'htzg';
const comein_channel = isBuild ? 'dbed2970-20d8-40b8-9ea9-d2d382fb0ff7' : 'd8833355-4b82-4dd4-9c19-dd271da1b22f';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'htzg';

// 睿远基金Bridge类 - 使用默认实现，不需要重写方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
